var map = {
	"./de.json": [
		1923,
		74
	],
	"./de_CH.json": [
		1924,
		75
	],
	"./de_DE.json": [
		1925,
		76
	],
	"./en.json": [
		679
	],
	"./en_CA.json": [
		1926,
		6
	],
	"./en_CH.json": [
		1883,
		3
	],
	"./en_GB.json": [
		1927,
		7
	],
	"./en_ZA.json": [
		1884,
		3
	],
	"./fr.json": [
		1928,
		77
	],
	"./fr_CA.json": [
		1929,
		2
	],
	"./fr_CH.json": [
		1930,
		2
	],
	"./it.json": [
		1931,
		78
	],
	"./it_CH.json": [
		1932,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 806;
module.exports = webpackAsyncContext;